import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/Sale/OrderClient/SaleOrderClientList/hooks/useOrderClientList';
import { OrderClientStateSelects } from '#app/typings/orderClient';

type Props = {
  handleSearch: (data: Filters) => void;
};

const Search: React.FC<Props> = ({ handleSearch }) => {
  const classes = useStyles();

  const [formSearch, setFormSearch] = useState<Form>({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
    },
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
    },
    name: {
      name: 'name',
      label: 'Client',
      textHelper: 'Rechercher par client.',
      type: 'text',
    },
    orderClientStates: {
      name: 'orderClientStates',
      label: 'État de la commande',
      textHelper: 'Rechercher par état.',
      type: 'array',
    },
  });

  const handlerForm = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerForm.start();
  }, []);

  const getData = (): Filters => {
    const data = handlerForm.getData();
    return {
      number: data.number,
      email: data.email,
      name: data.name,
      orderClientStates: data.orderClientStates,
    };
  };

  return (
    <ShadowBoxComponent className={classes.container}>
      <Grid container>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="number" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="email" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="name" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="orderClientStates"
            options={OrderClientStateSelects}
            handler={handlerForm}
          />
        </Grid>
        <ButtonComponent label="Rechercher" onClick={() => handleSearch(getData())} />
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  container: {
    marginBottom: 20,
  },
});

export default Search;
